import { getVideoEmbedUrl } from "../../../utils/media";
import "./style.css";

export default function Video({ video }) {
  const embedUrl = getVideoEmbedUrl(video?.url || video);

  if (video?.visible === false || !embedUrl) return null;

  return (
    <section className="home-video" aria-labelledby="home-video-title">
      <h2 id="home-video-title">Vídeo Institucional</h2>
      <div className="home-video__frame">
        <iframe
          src={embedUrl}
          title="Vídeo Institucional"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </section>
  );
}
